import { PROTECTED_PATHS } from "../../../app/constants";
import {
  errorNotifier,
  successNotifier,
} from "../../../components/NotificationHandler";
import http, { AUTH_ROUTES } from "../../../services/api";

// export const loginTenant = async (payload, setLoading, setIsLoggedin, setNextPage) => {
export const loginTenant = async (
  payload,
  setLoading,
  setIsLoggedin,
  setNextPage,
  setData
) => {
  try {
    const { MY_ESTATE } = PROTECTED_PATHS;
    setLoading(true);
    const {
      data: { result },
    } = await http.post(AUTH_ROUTES.LOGIN, payload);

    const token = result?.data?.userData?.token;
    const userId = result?.data?.userData?.userId;
    const tenantId = result?.data?.tenant?._id || userId;
    const reset = result?.data?.tenant?.resetPassword;
    const outstandingBalance = Number(result?.data?.tenant?.outstandingBalance || 0);
    const shouldRestrict = result?.data?.tenant?.shouldRestrict === true;

    if (!result.success) return { blocked: false };

    if (outstandingBalance > 0 && shouldRestrict) {
      setLoading(false);
      setIsLoggedin(false);
      errorNotifier(`Your account is restricted due to an outstanding balance of ₦${outstandingBalance.toFixed(2)}.`);
      return { blocked: true, outstandingBalance };
    }

    localStorage.setItem("11p221#", token);

    setData(result);
    setLoading(false);
    // setNextPage(true)

    if (reset) {
      setIsLoggedin(true);
      localStorage.setItem("userId", userId);
      // navigate('/home');
      successNotifier(result?.message);
      window.location.href = MY_ESTATE;
    } else {
      setNextPage(true);
    }
    // setIsLoggedin(true);
    localStorage.setItem("old", true);
    return { blocked: false };
  } catch (e) {
    console.log(e?.message, "ERR2", e?.toJSON()?.message === "Network Error");
      setLoading(false);
  
    setIsLoggedin(false);
    if (e?.response) {
      e.response?.data?.message
        ? errorNotifier(e.response?.data?.message)
        : errorNotifier(e.response?.data?.result?.message);
    } else {
      errorNotifier("Please Check your network connection!!!");
    }
    return { blocked: false };
  }
};
export const logoutTenant = async (setIsLoggedin, navigate) => {
  try {
    localStorage.removeItem("11p221#");
    localStorage.removeItem("userId");
    setIsLoggedin(false);
    navigate("/login");
  } catch (e) {
    console.error("Logout failed:", e);
    errorNotifier("Failed to log out. Please try again.");
  }
};
